<template>
    <div>
        <notification :notification="notification" @dismissAlert="dismiss"></notification>
        <form role="form" class="elr-form elr-container" @submit.prevent="update" id="update-pony">
            <ul v-show="errors.length">
                <li :key="e" v-for="e in errors">
                    <span :key="value" v-for="(key, value) in e">{{value}}: {{key[0]}}</span>
                </li>
            </ul>
            <div class="elr-row">
                <div class="elr-col-full">
                    <label for="name">Pony Name:</label>
                    <input type="text" placeholder="Pony Name" name="name" v-model="formData.name">
                </div>
            </div>
            <div class="elr-row">
                <div class="elr-col-half">
                    <label for="pose_id">Pose:</label>
                    <select name="pose_id" id="pose_id" v-model="formData.pose_id">
                        <option :key="pose.id" v-for="pose in this.poses" :value="pose.id">{{pose.name}}</option>
                    </select>
                </div>
                <div class="elr-col-half">
                    <label for="mold_id">Mold:</label>
                    <select name="mold_id" id="mold_id" v-model="formData.mold_id">
                        <option :key="mold.id" v-for="mold in this.molds" :value="mold.id">{{mold.name}}</option>
                    </select>
                </div>
            </div>
            <div class="elr-row">
                <div class="elr-col-half">
                    <label for="body_color">Color:</label>
                    <select name="body_color" id="body_color" v-model="formData.body_color">
                        <!-- <option value="">Select Color</option> -->
                        <option :key="color" v-for="color in this.colors" :value="color">{{color}}</option>
                    </select>
                </div>
                <div class="elr-col-half">
                    <label for="body_texture">Texture:</label>
                    <select name="body_texture" id="body_texture" v-model="formData.body_texture">
                        <!-- <option value="">Select Texture</option> -->
                        <option :key="texture" v-for="texture in this.bodyTextures" :value="texture">{{texture}}</option>
                    </select>
                </div>
            </div>
            <div class="elr-row">
                <div class="elr-col-half">
                    <label for="freckle_color">Freckle Color:</label>
                    <select name="freckle_color" id="freckle_color" v-model="formData.freckle_color">
                        <!-- <option value="">Select Freckle Color</option> -->
                        <option :key="color" v-for="color in this.colors" :value="color">{{color}}</option>
                    </select>
                </div>
                <div class="elr-col-half">
                    <label for="origin_lang_name">Origin Language Name:</label>
                    <input type="text" name="origin_lang_name" id="origin_lang_name" v-model="formData.origin_lang_name" placeholder="Nachtlicht">
                </div>
            </div>
            <div class="elr-row">
                <div class="elr-col-half">
                    <label for="eye_color">Eye Color:</label>
                    <select name="eye_color" id="eye_color" v-model="formData.eye_color">
                        <option :key="color" v-for="color in this.colors" :value="color">{{color}}</option>
                    </select>
                </div>
                <div class="elr-col-half">
                    <label for="eye_type">Eye Type:</label>
                    <select name="eye_type" id="eye_type" v-model="formData.eye_type">
                        <option :key="eyeType" v-for="eyeType in this.eyeTypes" :value="eyeType">{{eyeType}}</option>
                    </select>
                </div>
            </div>
            <div class="elr-row">
                <div class="elr-col-half">
                    <label for="mane_color">Mane Color:</label>
                    <select name="mane_color" id="mane_color" v-model="formData.mane_color">
                        <option :key="color" v-for="color in this.colors" :value="color">{{color}}</option>
                    </select>
                </div>
                <div class="elr-col-half">
                    <label for="tail_color">Tail Color:</label>
                    <select name="tail_color" id="tail_color" v-model="formData.tail_color">
                        <option :key="color" v-for="color in this.colors" :value="color">{{color}}</option>
                    </select>
                </div>
            </div>
            <div class="elr-row">
                <div class="elr-col-half">
                    <label for="theme">Theme:</label>
                    <select name="theme" id="theme" v-model="formData.theme">
                        <option :key="theme" v-for="theme in this.themes" :value="theme">{{theme}}</option>
                    </select>
                </div>
                <div class="elr-col-half">
                    <label for="symbol_type">Symbol Type:</label>
                    <select name="symbol_type" id="symbol_type" v-model="formData.symbol_type">
                        <option :key="symbolType" v-for="symbolType in this.symbolTypes" :value="symbolType">{{symbolType}}</option>
                    </select>
                </div>
            </div>
            <div class="elr-row">
                <div class="elr-col-half">
                    <label for="symbol_texture">Symbol Texture:</label>
                    <select name="symbol_texture" id="symbol_texture" v-model="formData.symbol_texture">
                        <option :key="symbolTexture" v-for="symbolTexture in this.symbolTextures" :value="symbolTexture">{{symbolTexture}}</option>
                    </select>
                </div>
                <div class="elr-col-half">
                    <label for="streak_color">Streak Color:</label>
                    <select name="streak_color" id="streak_color" v-model="formData.streak_color">
                        <option :key="color" v-for="color in this.colors" :value="color">{{color}}</option>
                    </select>
                </div>
            </div>
            <div class="elr-row">
                <div class="elr-col-half">
                    <label for="forelock_color">Forelock Color:</label>
                    <select name="forelock_color" id="forelock_color" v-model="formData.forelock_color">
                        <option :key="color" v-for="color in this.colors" :value="color">{{color}}</option>
                    </select>
                </div>
                <div class="elr-col-half">
                    <label for="tinsel_color">Tinsel Color:</label>
                    <select name="tinsel_color" id="tinsel_color" v-model="formData.tinsel_color">
                        <option :key="color" v-for="color in this.colors" :value="color">{{color}}</option>
                    </select>
                </div>
            </div>
            <div class="elr-row">
                <div class="elr-col-half">
                    <label for="hair_texture">Hair Texture:</label>
                    <select name="hair_texture" id="hair_texture" v-model="formData.hair_texture">
                        <option :key="hairTexture" v-for="hairTexture in this.hairTextures" :value="hairTexture">{{hairTexture}}</option>
                    </select>
                </div>
                <div class="elr-col-half">
                    <label for="hair_length">Hair Length:</label>
                    <select name="hair_length" id="hair_length" v-model="formData.hair_length">
                        <option :key="hairLength" v-for="hairLength in this.hairLengths" :value="hairLength">{{hairLength}}</option>
                    </select>
                </div>
            </div>
            <div class="elr-row">
                <div class="elr-col-half">
                    <label for="hoof_style">Hoof Style:</label>
                    <select name="hoof_style" id="hoof_style" v-model="formData.hoof_style">
                        <option :key="hoofStyle" v-for="hoofStyle in this.hoofStyles" :value="hoofStyle">{{hoofStyle}}</option>
                    </select>
                </div>
                <div class="elr-col-half">
                    <label for="age">Age:</label>
                    <select name="age" id="age" v-model="formData.age">
                        <option :key="age" v-for="age in this.ages" :value="age">{{age}}</option>
                    </select>
                </div>
            </div>
            <div class="elr-row">
                <div class="elr-col-half">
                    <label for="gender">Gender:</label>
                    <select name="gender" id="gender" v-model="formData.gender">
                        <option :key="gender" v-for="gender in this.genders" :value="gender">{{gender}}</option>
                    </select>
                </div>
            </div>
            <div class="elr-row">
                <div class="elr-col-half">
                    <label for="patent_status">Patent Status:</label>
                    <select name="patent_status" id="patent_status" v-model="formData.patent_status">
                        <option :key="patentStatus" v-for="patentStatus in this.patentStatuses" :value="patentStatus">{{patentStatus}}</option>
                    </select>
                </div>
                <div class="elr-col-half">
                    <label for="hoof_mark_decoration">Hoof Mark Decoration:</label>
                    <select name="hoof_mark_decoration" id="hoof_mark_decoration" v-model="formData.hoof_mark_decoration">
                        <option :key="hoofDecoration" v-for="hoofDecoration in this.hoofDecorations" :value="hoofDecoration">{{hoofDecoration}}</option>
                    </select>
                </div>
            </div>
            <div class="elr-row">
                <div class="elr-col-full">
                    <label for="symbol_description">Symbol Description:</label>
                    <textarea cols="30" rows="10" name="symbol_description" v-model="formData.symbol_description" placeholder="Symbol Description"></textarea>
                </div>
            </div>
            <div class="elr-row">
                <div class="elr-col-full">
                    <label for="notes">Notes:</label>
                    <textarea cols="30" rows="10" name="notes" v-model="formData.notes" placeholder="Notes"></textarea>
                </div>
            </div>
            <div class="elr-row">
                <div class="elr-col-full form-input-holder">
                    <button type="submit" class="elr-button elr-button-primary">Update Pony</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';
import Notification from '../Notification/Notification';
import {capitalize} from '../../utils/helpers';
import {
  bodyTextures,
  ages,
  eyeTypes,
  symbolTypes,
  symbolTextures,
  genders,
  hairTextures,
  hairLengths,
  hoofStyles,
  patentStatuses,
  hoofDecorations
} from '../../data/config.json';

export default {
  name: 'FormPonyEdit',
  props: ['id'],
  data() {
    return {
      colors: [],
      bodyTextures,
      ages,
      themes: [],
      eyeTypes,
      symbolTypes,
      symbolTextures,
      genders,
      hairTextures,
      hairLengths,
      hoofStyles,
      patentStatuses,
      hoofDecorations,
      errors: [],
      pony: this.pony,
      formData: this.pony,
      poses: [],
      molds: [],
      notification: {
        show: false,
        message: '',
        className: ''
      }
    };
  },
  components: {
    Notification
  },
  mounted() {
    axios.get(`${process.env.VUE_APP_ROOT_API}/pony/${this.id}`).then(({ data }) => {
      this.pony = data.pony;
      this.formData = data.pony;

      axios.get(`${process.env.VUE_APP_ROOT_API}/pony/form/${this.pony.grouping_id}`).then(({ data }) => {
        this.poses = data.poses;
        this.molds = data.molds;
      });
    });
  },
  methods: {
    capitalize,
    dismiss() {
      this.notification.show = false;
    },
    update() {
      axios
        .put(`${process.env.VUE_APP_ROOT_API}/pony/${this.id}`, this.formData)
        .then(({ data }) => {
          this.errors = [];

          if (data.item) {
            this.$emit('ponyUpdated', data.item);
            this.notification.show = true;
            this.notification.message = 'Pony updated successfully';
            this.notification.className = 'elr-alert-success';
          } else {
            this.resetForm();
            this.notification.show = true;
            this.notification.message =
              'There was problem a updating your pony';
            this.notification.className = 'elr-alert-danger';
            this.errors.push({
              error: ['Please try to update ponies later']
            });
          }
        })
        .catch(e => {
          this.errors = [];

          if (e.response) {
            this.notification.show = true;
            this.notification.message =
              'There was a problem updating your pony';
            this.notification.className = 'elr-alert-danger';
            this.errors.push(e.response.data.errors);
          }
        });
    }
  }
};
</script>
